import { render, staticRenderFns } from "./workoutCards.vue?vue&type=template&id=af034104&"
import script from "./workoutCards.vue?vue&type=script&lang=js&"
export * from "./workoutCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports